resourcePaths = '{"rootPath":"","assetsPath":""}';function MarketingNavigation () {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_AccessibleContainer, _ResponsiveLayout, _Secured];

  var _this = this;
  var documentElement = $(document);

  this.el = {};

  this._classes = {
    hamburger: 'js--marketing-nav__hamburger',
    dropdown: 'js--marketing-nav__dropdown',
    dropdownLink: 'js--marketing-nav__dropdown-link',
    toggleDropdown: 'js--toggle-dropdown',
    loggedOut: 'js--marketing-nav__logged-out',
    loggedIn: 'js--marketing-nav__logged-in',
    subNavLink: 'js--marketing-nav__subnav',
    mobileSubNavLink: 'js--marketing-nav__mobile-sub-link',
    outsideElement: 'page-content',
    trayOpen: 'marketing-nav-tray-open',
    hideSubNav: 'marketing-nav--hide-subnav',
    itemActive: 'marketing-nav__item-active',
    skipLink: 'marketing-nav-skip-links__link',
    mobileTray: 'marketing-nav-mobile-tray',
    companyNav: 'js--analytics-company'
  };

  this.init = function () {
    this.$node = $(this.node);
    this.el.$hamburger = $('.' + this._classes.hamburger);
    this.el.$dropdown = $('.' + this._classes.dropdown);
    this.el.$dropdownLink = $('.' + this._classes.dropdownLink);
    this.el.$toggleDropdown = $('.' + this._classes.toggleDropdown);
    this.el.$loggedOut = $('.' + this._classes.loggedOut);
    this.el.$loggedIn = $('.' + this._classes.loggedIn);
    this.el.$subNavLink = $('.' + this._classes.subNavLink);
    this.el.$outsideElement = $('.' + this._classes.outsideElement);
    this.el.$skipLink = $('.' + this._classes.skipLink);
    this.el.$mobileTray = $('.' + this._classes.mobileTray);
    this.el.$companyNav = $('.' + this._classes.companyNav);
    this.el.$body = $('body');

    this._focusDropdown();
    this._logOut();
    this._checkUserStatus();
    this._closeNav();
    this._toggleSubNav();
    this._focusSkipLink();
    this._previouslyFocusedElement();
    this._trapTab();

    this.el.$hamburger.on('click.toggleHamburger', this.setupToggleHamburger.bind(this));
    this._toggleDropdown();
    this.el.$outsideElement.on('click', this._closeEvent.bind(this));
    this.el.$companyNav.on('mouseover', this._analyticsCompany.bind(this));
  };

  this.initAllReady = function () {};

  this.toggleHamburger = function () {
    var checkTray = _this.el.$body.hasClass(_this._classes.trayOpen);

    if (checkTray) {
      this.el.$hamburger.trigger('click.toggleHamburger');
    }
  };

  this.setupToggleHamburger = function (event) {
    event.preventDefault();
    this.el.$body.toggleClass(this._classes.trayOpen);

    if (this.el.$body.hasClass(this._classes.trayOpen)) {
      this.el.$mobileTray.removeAttr('tabindex');
      this._accessibilityVisibility(true);
    } else {
      this.el.$mobileTray.attr('tabindex', -1);
      this._accessibilityVisibility(false);
    }
  };

  this._toggleSubNav = function () {
    this.el.$subNavLink.on({
      mouseenter: function () {
        _this.el.$subNavLink.not($(this)).addClass(_this._classes.hideSubNav);
      },
      mouseleave: function () {
        _this.el.$subNavLink.not($(this)).removeClass(_this._classes.hideSubNav);
      }
    });
  };

  // revert for the way it was done in investors
  this._toggleDropdown = function () {
    var _this = this;

    this.el.$dropdown.click(function () {
      // Checking the page to see if its in products or company category.
      // if current page is in related category, then nav is opened by css.
      var attr = $(this).attr('page');
      if ($(this).hasClass('page-products') && attr === ('page-products')) {
        $(this).removeAttr('page');
      } else if ($(this).hasClass('page-company') && attr === ('page-company')) {
        $(this).removeAttr('page');
      } else {
        $(this).toggleClass(_this._classes.itemActive);
      }

      var $links = $(this).find('.' + _this._classes.mobileSubNavLink);

      if ($(this).hasClass(_this._classes.itemActive)) {
        $links.removeAttr('tabindex');
      } else {
        $links.attr('tabindex', -1);
      }
    });
  };

  this._focusDropdown = function () {
    var dropDownNav = '.js--marketing-nav__subnav';
    var dropDownFocus = 'marketing-nav__submenu-dropdown--focus';

    this.el.$dropdownLink.focus(function () {
      $(this)
        .parents(dropDownNav)
        .addClass(dropDownFocus);
    });

    this.el.$dropdownLink.blur(function () {
      $(this)
        .parents(dropDownNav)
        .removeClass(dropDownFocus);
    });

    this.el.$toggleDropdown.click(function (event) {
      if ($(this).attr('href') === '#') {
        event.preventDefault();
      }
    });
  };

  this._focusSkipLink = function () {
    var skipLinkFocus = 'marketing-nav-skip-links--focus';
    var skipLinkContainer = '.marketing-nav-skip-links';

    this.el.$skipLink.focus(function () {
      $(this)
        .parents(skipLinkContainer)
        .addClass(skipLinkFocus);
    });

    this.el.$skipLink.blur(function () {
      $(this)
        .parents(skipLinkContainer)
        .removeClass(skipLinkFocus);
    });

    // this is so you can keep tabbing to the next links instead of going to the next skip link
    this.el.$skipLink.click(function (event) {
      // strip the leading hash and declare
      // the content we're skipping to
      var skipTo = '#' + this.href.split('#')[1];

      // Setting 'tabindex' to -1 takes an element out of normal
      // tab flow but allows it to be focused via javascript
      $(skipTo)
        .attr('tabindex', -1)
        .on('blur focusout', function () {
          // when focus leaves this element,
          // remove the tabindex attribute
          $(this).removeAttr('tabindex');
        })
        .focus(); // focus on the content container
    });
  };

  this._logOut = function () {
    if (this.$node.find('.logout').length > 0) {
      this.$node.find('.logout').on('click', $.proxy(this._onLogout, this));
    }
  };

  this._checkUserStatus = function () {
    if (this.isLoggedIn()) {
      this.el.$loggedIn.removeClass('hide');
    } else {
      this.el.$loggedOut.removeClass('hide');
    }
  };

  this._closeNav = function () {
    documentElement.keyup(function (e) {
      if (e.keyCode === 27) {
        if (_this.el.$body.hasClass(_this._classes.trayOpen)) {
          _this._closeEvent();
        }
      }
    });
  };

  this._closeEvent = function () {
    this.el.$body.removeClass(_this._classes.trayOpen);
  };

  this._analyticsCompany = function () {
    dataLayer.push({
      event: 'DLevent.marketingNavigation',
      marketingNavigation: 'Hover Company'
    });
  };
}
